import { render, staticRenderFns } from "./CardAnswerView.vue?vue&type=template&id=7dcba36e&scoped=true&"
import script from "./CardAnswerView.vue?vue&type=script&lang=js&"
export * from "./CardAnswerView.vue?vue&type=script&lang=js&"
import style0 from "./CardAnswerView.vue?vue&type=style&index=0&id=7dcba36e&prod&lang=scss&scoped=true&"
import style1 from "./CardAnswerView.vue?vue&type=style&index=1&id=7dcba36e&prod&lang=scss&"
import style2 from "./CardAnswerView.vue?vue&type=style&index=2&id=7dcba36e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcba36e",
  null
  
)

export default component.exports